The earliest event to include.
